<template>
  <div class="container">
    <div class="row">
      <div class="col center">
        <h1>Frequently Asked Questions</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div role="tablist">
          <b-card no-body class="mb-3" v-for="accordion in accordions" :key="accordion.id">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-button
                block
                v-b-toggle="`accordion${accordion.id}`"
                variant="primary"
                size="lg"
              >{{accordion.title}}</b-button>
            </b-card-header>
            <b-collapse :id="`accordion${accordion.id}`" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>{{ accordion.text }}</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accordions: [
        {
          title: "How can you help my business?",
          text:
            "If you are stuck in a debt cycle, which means you have to take another advance in an attempt to pay back your previous ones, let us help you. We can restructure or settle your debt for significantly reduced sums.",
          id: "1"
        },
        {
          title: "How long does the program take?",
          text:
            "Generally, the program takes from 3 to 24 months. Once you’re approved, we can work out a plan that will best suit your needs.",
          id: "2"
        },
        {
          title: "How much does it cost?",
          text:
            "There is a small enrollment fee, but most our earnings are based on performance. We charge a service fee for the proportion of the money we save you. If we are unable to settle your debt, the money in your trust account will be returned to you immediately.",
          id: "3"
        },
        {
          title: "Are you a Law Firm?",
          text:
            "We are not a Law Firm and we do not provide legal advice. However, we are affiliated with a nationwide network of attorneys that can assist us when necessary.",
          id: "4"
        },
        {
          title: "How are you different?",
          text:
            "While cash advance lenders may urge you to take out more and more MCAs, making you slide into the quagmire of debt, we at Business Debt Adjusters help small business owners like yours get out of debt trap once and for all. We advocate for your business against the lenders and work to get your payments reduced to a number you can afford or even get the balance decreased.",
          id: "5"
        },
        {
          title: "What types of business do you work with?",
          text:
            "We deal with a host of businesses nationwide, ranging from restaurants and beauty salons to automotive repair shops and medical providers.",
          id: "6"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  margin: 20px 0;

  h1{
    font-weight: 700;
  }
}
</style>